"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsOutlookAddon = void 0;
const getIsOutlookAddon = () => {
    const officeDiagnostics = window?.Office?.context?.diagnostics;
    if (!officeDiagnostics) {
        return false;
    }
    const platform = officeDiagnostics?.platform;
    return (platform && [
        window?.Office.PlatformType.PC,
        window?.Office.PlatformType.iOS,
        window?.Office.PlatformType.Mac,
    ].includes(platform));
};
exports.getIsOutlookAddon = getIsOutlookAddon;
